import { MarketplaceCompanyInfoJSON } from "marketplace/_schema/marketplace-company-info-schema";
import { getCityAndStateText } from "marketplace/_views/result-text";

/**
 * What a company result says about the company on one line under its name. The search returns all
 * of these; before #5401 the card showed none of them.
 */
export type CompanyResultSummary = {
  location?: string;
  website?: { href?: string; label: string };
  size?: string;
  established?: string;
};

export function getCompanyResultSummary(result: MarketplaceCompanyInfoJSON): CompanyResultSummary {
  return {
    location: getCityAndStateText(result.location) || undefined,
    website: getWebsite(result.website),
    size: getSizeText(result.numberOfEmployees),
    established: result.yearEstablished ? `Est. ${result.yearEstablished}` : undefined,
  };
}

function getWebsite(website: string | null | undefined): CompanyResultSummary["website"] {
  const trimmed = website?.trim();
  if (!trimmed) return undefined;

  const label = trimmed.replace(/^https?:\/\//i, "").replace(/\/+$/, "");
  if (/^https?:\/\//i.test(trimmed)) return { href: trimmed, label };
  // Any other scheme (javascript:, data:, mailto:) is shown as text and never becomes a link, since
  // the value is whatever the company typed into its profile.
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return { label: trimmed };
  return { href: `https://${trimmed}`, label };
}

function getSizeText(numberOfEmployees: number | null | undefined): string | undefined {
  if (!numberOfEmployees || numberOfEmployees < 1) return undefined;
  return `${numberOfEmployees.toLocaleString("en-US")} ${numberOfEmployees === 1 ? "employee" : "employees"}`;
}
